<template>
  <div class="container">
    <wrap-container class="relative-container column-container">
      <step-header />
      <form-validator>
        <wrap-container class="col1">
          <branch-offices
            v-model="model.numSucursal"
            :required="true"
            v-on:address="saveAddress"
          />
        </wrap-container>
        <wrap-container class="col1 check-container">
          <section-label class="subtitle" :value="config.pasos.paso4.copy" />
          <custom-checkbox
            :value="model.financiacion"
            v-on:input="onFinanciacion"
            :label="productos.producto1.titulo"
            :description="productos.producto1.descripcion"
          />
          <custom-checkbox
            v-if="!isPF"
            :value="model.cobrosPagos"
            v-on:input="onCobros"
            :label="productos.producto2.titulo"
            :description="productos.producto2.descripcion"
          />
          <custom-checkbox
            v-if="isPF"
            :value="model.seguroComercio"
            v-on:input="onSeguroComercio"
            :label="productos.producto2.titulo"
            :description="productos.producto2.descripcion"
          />
        </wrap-container>
        <step-navigator :store-action="this.doNext" v-model="model" />
      </form-validator>
    </wrap-container>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import StepNavigator from "@/components/core/StepNavigator";
import StepHeader from "@/components/core/StepHeader";
import FormValidator from "@/components/core/FormValidator";
import BranchOffices from "@/components/core/custom/BranchOffices";
import CustomCheckbox from "@/components/core/custom/CustomCheckbox";
import SectionLabel from "@/components/core/SectionLabel";
import { DO_PASO4 } from "../config/constants/action-types";
import {
  productosEmpresa,
  productosEmprendedor
} from "@/config/constants/paso4-productos";

export default {
  name: "Paso4",
  data() {
    return {
      model: this.$store.getters.getPaso4(),
      doNext: DO_PASO4
    };
  },
  components: {
    StepNavigator,
    StepHeader,
    WrapContainer,
    FormValidator,
    BranchOffices,
    CustomCheckbox,
    SectionLabel
  },
  methods: {
    onCobros(val) {
      this.model.cobrosPagos = val;
    },
    onFinanciacion(val) {
      this.model.financiacion = val;
    },
    saveAddress(address) {
      this.model.dirSucursal = this.model.numSucursal + " - " + address;
    },
    onSeguroComercio(val) {
      this.model.seguroComercio = val;
    }
  },
  computed: {
    isPF() {
      return this.$store.getters.getPaso1().esPF === true;
    },
    productos() {
      return this.isPF === true ? productosEmprendedor : productosEmpresa;
    }
  }
};
</script>
<style scoped>
.check-container {
  margin-top: 20px;
}

.subtitle {
  margin-bottom: 20px;
}
</style>
